import { render } from "./ParameterComponent.vue?vue&type=template&id=5066a7a8"
import script from "./ParameterComponent.vue?vue&type=script&lang=js"
export * from "./ParameterComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__